import React, { Component } from "react";
import {
  loading,
  NavbarCustomer,
  t
} from "../../components/CustomComponent.js"; // ปรับ Path ให้ตรงกับโปรเจกต์ของคุณ

export default class AssetReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // -----------------------------------
      // Filter States
      // -----------------------------------
      filter_category: "All Categories",
      filter_status: "All Status",
      filter_location: "All Locations",

      // -----------------------------------
      // Mock Data: Summary Stats
      // -----------------------------------
      summary: {
        total: 48,
        total_change: "+8% vs previous",
        completed: 42,
        completed_rate: "87.5% completion",
        in_progress: 4,
        in_progress_rate: "8.3% of total",
        pending: 2,
        pending_rate: "4.2% of total"
      },
      
      // -----------------------------------
      // Mock Data: Asset Inventory
      // -----------------------------------
      data: [
        { id: "AST-001", name: "Chiller Unit #1", category: "HVAC", location: "Building A", status: "Operational", statusColor: "success", last_pm: "Jan 15, 2025", next_pm: "Apr 15, 2025", warranty: "Active", warrantyColor: "success" },
        { id: "AST-002", name: "Chiller Unit #2", category: "HVAC", location: "Building A", status: "Maintenance", statusColor: "warning", last_pm: "Feb 10, 2025", next_pm: "May 10, 2025", warranty: "Expiring", warrantyColor: "warning" },
        { id: "AST-003", name: "Chiller Unit #3", category: "HVAC", location: "Building B", status: "Operational", statusColor: "success", last_pm: "Dec 20, 2024", next_pm: "Mar 20, 2025", warranty: "Active", warrantyColor: "success" },
        { id: "AST-004", name: "AHU-01", category: "HVAC", location: "Building A", status: "Operational", statusColor: "success", last_pm: "Jan 5, 2025", next_pm: "Apr 5, 2025", warranty: "Active", warrantyColor: "success" },
        { id: "AST-005", name: "Generator Set", category: "Electrical", location: "Warehouse", status: "Operational", statusColor: "success", last_pm: "Feb 1, 2025", next_pm: "May 1, 2025", warranty: "Expired", warrantyColor: "danger" }
      ]
    };
  }

  async componentDidMount() {
    loading(false);
  }

  render() {
    const { summary, data } = this.state;

    return (
      <div className="w-100 min-vh-100 pb-5" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarCustomer />
        <div className="body px-4 mt-3">


                    {/* Header Section */}
                    <div className="mb-4">
                      <h3 className="fw-bold mb-1 text-dark">{t("asset_report")}</h3>
                      <div className="text-secondary text-14">{t("equipment_status_desc")}</div>
                    </div>
          
                    {/* Filter Bar */}
                    <div className="bg-white rounded-4 shadow-sm p-3 mb-4 d-flex flex-wrap align-items-end gap-3 border border-light">
                      <div className="flex-grow-1" style={{ minWidth: '200px' }}>
                        <label className="form-label text-secondary text-12 fw-bold mb-2">{t("asset_category")}</label>
                        <select className="form-select rounded-3 border-light bg-light text-dark fw-bold text-13 shadow-none">
                          <option>{t("last_30_days")}</option>
                        </select>
                      </div>
                      <div className="flex-grow-1" style={{ minWidth: '200px' }}>
                        <label className="form-label text-secondary text-12 fw-bold mb-2">{t("status")}</label>
                        <select className="form-select rounded-3 border-light bg-light text-dark fw-bold text-13 shadow-none">
                          <option>{t("all_status")}</option>
                        </select>
                      </div>
                      <div className="flex-grow-1" style={{ minWidth: '200px' }}>
                        <label className="form-label text-secondary text-12 fw-bold mb-2">{t("location")}</label>
                        <select className="form-select rounded-3 border-light bg-light text-dark fw-bold text-13 shadow-none">
                          <option>{t("all_categories")}</option>
                        </select>
                      </div>
                      <button className="btn btn-primary px-4 fw-bold rounded-3 shadow-sm border-0 d-flex align-items-center" style={{ height: '42px' }}>
                        <span className="icon me-2">{"\uf0b0"}</span> {t("apply_filters")}
                      </button>
                    </div>
          
                    {/* KPI Summary Cards */}
                    <div className="row g-3 mb-4">
                      <div className="col-lg-3 col-md-6">
                        <div className="card border-0 border-start border-5 border-primary rounded-4 shadow-sm p-3 bg-white h-100">
                          <div className="text-primary text-12 fw-bold mb-1">{t("total_assets")}</div>
                          <h2 className="fw-bold text-dark mb-1">{summary.total}</h2>
                          <div className="text-primary text-10 fw-bold">{t("under_contract")}</div>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6">
                        <div className="card border-0 border-start border-5 border-success rounded-4 shadow-sm p-3 bg-white h-100">
                          <div className="text-success text-12 fw-bold mb-1">{t("operational")}</div>
                          <h2 className="fw-bold text-dark mb-1">{summary.completed}</h2>
                          <div className="text-success text-10 fw-bold">{t("uptime")}</div>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6">
                        <div className="card border-0 border-start border-5 border-warning rounded-4 shadow-sm p-3 bg-white h-100">
                          <div className="text-warning text-12 fw-bold mb-1">{t("under_maintenance")}</div>
                          <h2 className="fw-bold text-dark mb-1">{summary.in_progress}</h2>
                          <div className="text-warning text-10 fw-bold">{t("scheduled_pm")}</div>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6">
                        <div className="card border-0 border-start border-5 border-danger rounded-4 shadow-sm p-3 bg-white h-100">
                          <div className="text-danger text-12 fw-bold mb-1">{t("warranty_expiring")}</div>
                          <h2 className="fw-bold text-dark mb-1">{summary.pending}</h2>
                          <div className="text-danger text-10 fw-bold">{t("within_30_days")}</div>
                        </div>
                      </div>
                    </div>
          
                    {/* Graphs Area */}
                    <div className="row g-4 mb-4">
                      <div className="col-lg-8">
                        <div className="card border-0 rounded-4 shadow-sm p-4 bg-white h-100">
                          <h6 className="fw-bold text-dark mb-4">{t("asset_status_distribution")}</h6>
                          <div className="d-flex align-items-center justify-content-center bg-light rounded-3" style={{ height: '250px' }}>
                            <span className="text-secondary opacity-50">[ Area Chart Placeholder ]</span>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="card border-0 rounded-4 shadow-sm p-4 bg-white h-100">
                          <h6 className="fw-bold text-dark mb-4">{t("maintenance_by_asset")}</h6>
                          <div className="d-flex align-items-center justify-content-center" style={{ height: '250px' }}>
                             <div className="position-relative d-flex align-items-center justify-content-center">
                                <div className="rounded-circle border border-5 border-success" style={{ width: '150px', height: '150px' }}></div>
                                <div className="position-absolute icon text-success text-24">{"\uf200"}</div>
                             </div>
                          </div>
                        </div>
                      </div>
                    </div>
          
                    {/* Details Table */}
                    <div className="card border-0 rounded-4 shadow-sm pb-2 overflow-hidden bg-white">
                      <div className="p-4 border-bottom border-light">
                        <h6 className="fw-bold text-dark mb-0">{t("service_request_details")}</h6>
                      </div>
                      <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0">
                          <thead>
                            <tr className="text-secondary fw-bold text-12 border-bottom border-light bg-light bg-opacity-50">
                              <th className="py-3 px-4 border-0">{t("asset_id")}</th>
                              <th className="py-3 border-0">{t("name")}</th>
                              <th className="py-3 border-0">{t("category")}</th>
                              <th className="py-3 border-0">{t("location")}</th>
                              <th className="py-3 border-0 text-center">{t("status")}</th>
                              <th className="py-3 border-0 text-center">{t("last_pm")}</th>
                              <th className="py-3 border-0 text-center">{t("next_pm")}</th>
                              <th className="py-3 border-0 text-center">{t("warranty")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {data.map((item, idx) => (
                              <tr key={idx} className="border-bottom border-light">
                                 <td className="py-3 px-4 fw-bold text-primary text-13" style={{ color: "#8A2BE2" }}>{item.id}</td>
                                    <td className="text-dark fw-medium text-13">{item.name}</td>
                                    <td className="text-secondary text-13">{item.category}</td>
                                    <td className="text-secondary text-13">{item.location}</td>
                                    <td>
                                        <span className={`badge bg-${item.statusColor}-light text-${item.statusColor} rounded-pill px-3 py-1 fw-bold text-10 border border-${item.statusColor} border-opacity-10`}>
                                            {item.status}
                                        </span>
                                    </td>
                                    <td className="text-secondary text-13">{item.last_pm}</td>
                                    <td className="text-secondary text-13">{item.next_pm}</td>
                                    <td className="px-4">
                                        <span className={`badge bg-${item.warrantyColor}-light text-${item.warrantyColor} rounded-pill px-3 py-1 fw-bold text-10 border border-${item.warrantyColor} border-opacity-10`}>
                                            {item.warranty}
                                        </span>
                                    </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
          
                    {/* Footer Actions */}
                    {/* <div className="d-flex justify-content-between align-items-center mt-4 bg-white p-3 rounded-4 shadow-sm border border-light">
                      <div className="text-secondary text-12">
                        {t("report_generated")}: Feb 19, 2026 at 10:30 AM
                      </div>
                      <div className="d-flex gap-2">
                        <button className="btn btn-white border px-3 py-2 text-danger fw-bold rounded-3 d-flex align-items-center shadow-none">
                          <span className="icon me-2">{"\uf1c1"}</span> {t("export_pdf")}
                        </button>
                        <button className="btn btn-white border px-3 py-2 text-success fw-bold rounded-3 d-flex align-items-center shadow-none">
                          <span className="icon me-2">{"\uf1c3"}</span> {t("export_excel")}
                        </button>
                        <button className="btn btn-primary px-4 py-2 fw-bold rounded-3 shadow-sm border-0 d-flex align-items-center">
                          <span className="icon me-2">{"\uf02f"}</span> {t("print_report")}
                        </button>
                      </div>
                    </div> */}
        </div>
      </div>
    );
  }
}